import { render, staticRenderFns } from "./BusinessUnitsView.vue?vue&type=template&id=4bd07948&scoped=true&"
import script from "./BusinessUnitsView.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd07948",
  null
  
)

export default component.exports